import {
  TrackEventData,
  TrackEventService,
} from '@maximizer/core/shared/data-access';
import { OutlookStore } from '../state';
import { Injectable } from '@angular/core';
import { Event, EventMetadata } from '@maximizer/outlook/shared/domain';
import { OutlookService } from './outlook/outlook.service';

@Injectable()
export class TrackerService {
  constructor(
    private readonly tracker: TrackEventService,
    private readonly outlookStore: OutlookStore,
    private readonly outlookService: OutlookService,
  ) {}

  trackEvent(data: TrackEventData): void {
    const enrichedMetadata = {
      ...data.metadata,
      mailboxType: this.outlookStore.mailboxType(),
      direction: this.getDirectionProperty(),
      outlookModule: this.outlookService.isCalendarItem
        ? EventMetadata.Calendar
        : EventMetadata.Mail,
    };

    const eventData = {
      module: data.module,
      journey: data.journey,
      action: data.action,
      metadata: enrichedMetadata,
    };

    this.tracker.trackEvent(eventData);
  }

  trackPageView(name: string): void {
    const metadata = {
      name,
      mailboxType: this.outlookStore.mailboxType(),
    };
    this.tracker.trackEvent({
      event: Event.PageView,
      metadata,
    });
  }

  private getDirectionProperty(): EventMetadata {
    const isSentFolder = this.outlookStore.isSentFolder();

    return this.outlookService.isCompose ||
      isSentFolder ||
      this.outlookService.isCalendarCompose
      ? EventMetadata.Outgoing
      : EventMetadata.Incoming;
  }
}
